<nz-layout class="app-layout">
  <nz-layout>
    <nz-content>
      <div class="inner-content">
        <ng-content></ng-content>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
